/**
 * @generated SignedSource<<aa22d15bf3bcc8fd880611ada95ca730>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProcessOrgFileMutation$variables = {
  input: string;
};
export type ProcessOrgFileMutation$data = {
  readonly processOrgFile: string | null | undefined;
};
export type ProcessOrgFileMutation = {
  response: ProcessOrgFileMutation$data;
  variables: ProcessOrgFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "processOrgFile",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProcessOrgFileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProcessOrgFileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3dd81386173beb6160b33de8722a8ed9",
    "id": null,
    "metadata": {},
    "name": "ProcessOrgFileMutation",
    "operationKind": "mutation",
    "text": "mutation ProcessOrgFileMutation(\n  $input: String!\n) {\n  processOrgFile(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "762ed28a5b6dfe5618c9d524e259e10a";

export default node;
